import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  Text,
  Title,
  TITLE_VARIANT_MODAL,
  ModalHead,
  SpacingVertical,
  Link
} from 'mailup-web-components'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { modalAIAssistant } from './recoil/state/modal'
import {
  STORE_KEY_ACCOUNT,
  evalCondition,
  getLang,
  notifyParent,
  storeGet
} from 'mailup-react-helpers'
import iconIt from '../../img/ai-assistant-upgrade-ita.svg'
import iconEn from '../../img/ai-assistant-upgrade-eng.svg'
import iconEs from '../../img/ai-assistant-upgrade-esp.svg'
import iconSIt from '../../img/ai-assistant-trial-ita-S.svg'
import iconSEn from '../../img/ai-assistant-trial-eng-S.svg'
import iconSEs from '../../img/ai-assistant-trial-esp-S.svg'
import styled from '@emotion/styled'

const StyledImg = styled.img`
  width: 100%;
  height: 200px;
`

const StyledImgContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`

const ModalAiAssistantBee = ({ showBuy }) => {
  const intl = useIntl()
  const { IsTrial, Language } = storeGet(STORE_KEY_ACCOUNT)
  const { show } = useRecoilValue(modalAIAssistant)
  const reset = useResetRecoilState(modalAIAssistant)

  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  const goToMshop = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshopproddet&cp=MUAI'
    ])
  }

  const onClickLink1 = () => {
    const lang = getLang()
    let url = ''
    switch (lang) {
      case 'it':
        url =
          'https://helpmailup.atlassian.net/wiki/spaces/MM/pages/95879235/Assistente+AI'
        break
      case 'es':
        url =
          'https://helpmailup.atlassian.net/wiki/spaces/MMES/pages/37044064/Assistente+AI'
        break
      default:
        url =
          'https://helpmailup.atlassian.net/wiki/spaces/MUG/pages/36878343/AI+assistant'
        break
    }
    window.open(url, '_blank','noopener,noreferrer')
  }

  const onClickLink6 = () => {
    const lang = getLang()
    let url = ''
    switch (lang) {
      case 'it':
        url = 'https://mailup.it/contratto-di-licenza-uso/'
        break
      case 'es':
        url = 'https://mailup.es/contrato-de-licencia-de-uso/'
        break
      default:
        url = 'https://mailup.es/contrato-de-licencia-de-uso/'
        break
    }
    window.open(url, '_blank','noopener,noreferrer')
  }

  return (
    <Modal
      size={IsTrial ? 'L' : 'XL'}
      show={show}
      onClose={reset}
      showClose
      closeOnOverlayClick
      data-mu-test='buy-collaboration-modal'
      className='c-modal-buy-collaboration'
    >
      <ModalHead>
        <Title variant={TITLE_VARIANT_MODAL}>
          {IsTrial && (
            <>
              {intl.formatMessage({
                id: 'Load.Bee.UpsellAiTitlePromo'
              })}
            </>
          )}
          {showBuy && !IsTrial && (
            <>
              {intl.formatMessage({
                id: 'Load.Bee.UpsellAiTitleUpsell'
              })}
            </>
          )}
          {!showBuy && !IsTrial && (
            <>
              {intl.formatMessage({
                id: 'Load.Bee.UpsellAiTitleInfo'
              })}
            </>
          )}
        </Title>
      </ModalHead>
      <ModalBody>
        <SpacingVertical />
        <Text>
          {IsTrial && (
            <>
              {intl.formatMessage({
                id: 'Load.Bee.UpsellAiBodyPromo'
              })}
            </>
          )}
          {showBuy && !IsTrial && (
            <>
              {showMshop ? (
                <>
                  {intl.formatMessage(
                    {
                      id: 'Load.Bee.UpsellAiBodyUpsell'
                    },
                    {
                      strong: str => <strong>{str}</strong>
                    }
                  )}
                </>
              ) : (
                <>
                  {intl.formatMessage(
                    {
                      id: 'Load.Bee.UpsellAiBodyNoMshop'
                    },
                    {
                      strong: str => <strong>{str}</strong>
                    }
                  )}
                </>
              )}
            </>
          )}
          {!showBuy && !IsTrial && (
            <>
              {intl.formatMessage(
                {
                  id: 'Load.Bee.UpsellAiBodyInfo'
                },
                {
                  strong: str => <strong>{str}</strong>
                }
              )}
            </>
          )}
        </Text>
        <SpacingVertical />
        <StyledImgContainer>
          {IsTrial ? (
            <StyledImg
              src={
                Language === 'it'
                  ? iconSIt
                  : Language === 'es'
                  ? iconSEs
                  : iconSEn
              }
            />
          ) : (
            <StyledImg
              src={
                Language === 'it' ? iconIt : Language === 'es' ? iconEs : iconEn
              }
            />
          )}
          <SpacingVertical variant='8' />
          <Text variant='small-light'>
            {intl.formatMessage({
              id: 'Load.Bee.UpsellAiHintSample'
            })}
          </Text>
        </StyledImgContainer>
        <SpacingVertical variant='8' />
        <Text variant='extrasmall-light'>
          {intl.formatMessage(
            {
              id: 'Load.Bee.DisclaimerAi'
            },
            {
              linebreak: (
                <>
                  <br />
                </>
              ),
              link1: chunks => (
                <Link variant='highlight' onClick={onClickLink1}>
                  {chunks}
                </Link>
              ),
              link2: chunks => (
                <Link
                  variant='highlight'
                  onClick={() =>
                    window
                      .open(
                        'https://openai.com/policies/terms-of-use',
                        '_blank',
                        'noopener,noreferrer'
                      )
                  }
                >
                  {chunks}
                </Link>
              ),
              link3: chunks => (
                <Link
                  variant='highlight'
                  onClick={() =>
                    window
                      .open(
                        'https://openai.com/policies/eu-terms-of-use',
                        '_blank',
                        'noopener,noreferrer'
                      )
                  }
                >
                  {chunks}
                </Link>
              ),
              link4: chunks => (
                <Link
                  variant='highlight'
                  onClick={() =>
                    window
                      .open(
                        'https://openai.com/policies/usage-policies',
                        '_blank',
                        'noopener,noreferrer'
                      )
                  }
                >
                  {chunks}
                </Link>
              ),
              link5: chunks => (
                <Link
                  variant='highlight'
                  onClick={() =>
                    window
                      .open(
                        'https://platform.openai.com/docs/guides/safety-best-practices',
                        '_blank',
                        'noopener,noreferrer'
                      )
                  }
                >
                  {chunks}
                </Link>
              ),
              link6: chunks => (
                <Link variant='highlight' onClick={onClickLink6}>
                  {chunks}
                </Link>
              )
            }
          )}
        </Text>
      </ModalBody>
      <ModalFoot>
        <Button
          onClick={reset}
          kind={IsTrial || !showMshop || !showBuy ? 'primary' : 'secondary'}
        >
          {intl.formatMessage({
            id: 'Load.Common.Close'
          })}
        </Button>
        {showMshop && showBuy && (
          <Button onClick={goToMshop} kind='primary'>
            {intl.formatMessage({
              id: 'Load.Bee.UpsellAiCtaBuy'
            })}
          </Button>
        )}
      </ModalFoot>
    </Modal>
  )
}

ModalAiAssistantBee.propTypes = {
  showBuy: PropTypes.bool
}

export default ModalAiAssistantBee
